"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddOrUpdateCompanyMemberRequestV2 = void 0;
var AddOrUpdateCompanyMemberRequestV2;
(function (AddOrUpdateCompanyMemberRequestV2) {
    let Role;
    (function (Role) {
        Role["WORKSPACE_USER"] = "WorkspaceUser";
        Role["WORKSPACE_ADMINISTRATOR"] = "WorkspaceAdministrator";
    })(Role = AddOrUpdateCompanyMemberRequestV2.Role || (AddOrUpdateCompanyMemberRequestV2.Role = {}));
})(AddOrUpdateCompanyMemberRequestV2 || (exports.AddOrUpdateCompanyMemberRequestV2 = AddOrUpdateCompanyMemberRequestV2 = {}));
